import { createAction, props } from '@ngrx/store';

import { PaisDocumento, Error } from '@rpe/registro-personas-empresas-lib';

// LOAD
export const entityPaisesDocumentoLoadRequest = createAction(
  '[ENTITYPAISESDOCUMENTO] Load Request'
);

export const entityPaisesDocumentoLoadFailure = createAction(
  '[ENTITYPAISESDOCUMENTO] Load Failure',
  props<{ error: Error }>()
);

export const entityPaisesDocumentoLoadSuccess = createAction(
  '[ENTITYPAISESDOCUMENTO] Load Success',
  props<{ items: PaisDocumento[] }>()
);
